export const PastWebinarsSlider = function () {
	this.selectors = {
		itemsWrapper: jQuery('.past-webinars .ecs-posts'),
	};

	this.state = {
		owl: null,
	};

	this.config = {
		owl: {
			margin: 18,
			nav: true,
			dots: false,
			autoplay: false,
			autoplayTimeout: 6000,
			smartSpeed: 1000,
			dragEndSpeed: 1000,
			autoplayHoverPause: false,
			responsive: {
				0: {
					items: 1,
				},
				768: {
					items: 2,
				},
				1025: {
					items: 3,
				},
			},
		},
	};

	this.init = () => {
		this.owlInit();
	};

	this.owlInit = () => {
		this.createOwl();
	};

	this.createOwl = () => {
		const $itemsWrapper = this.selectors.itemsWrapper;

		if ($itemsWrapper.length < 1) {
			return;
		}

		const owl = this.state.owl;

		if (owl) {
			return;
		}

		$itemsWrapper.addClass('owl-carousel');

		this.state.owl = $itemsWrapper.owlCarousel(this.config.owl);
	};

	this.destroyOwl = () => {
		const owl = this.state.owl;

		if (!owl) {
			return;
		}

		owl.trigger('destroy.owl.carousel');

		this.state.owl = null;
		this.selectors.itemsWrapper.removeClass('owl-carousel');
	};
};
